import { ReactNode } from 'react'
import styled from 'styled-components'

export type SectionProps = {
  children?: ReactNode
  display?: string
  onClick?: () => void
  width?: string
  height?: string
  $margin?: string
  $gap?: string
  $justify_content?: string
  $border_radius?: string
  $bgColor?: string
  border?: string
  $align_item?: string
  style?: Object
}

const Section = (props: SectionProps) => {
  return (
    <SectionWrap {...props} onClick={props.onClick} style={props.style}>
      {props.children}
    </SectionWrap>
  )
}

export default Section

const SectionWrap = styled.section<SectionProps>`
  display: ${(props) => props.display || 'block'};
  height: ${(props) => props.height || ' auto'};
  width: ${(props) => props.width || 'auto'};
  margin: ${(props) => props.$margin || 0};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'unset')};
  gap: ${(props) => props.$gap};
  background: ${(props) => props.$bgColor};
  justify-content: ${(props) => props.$justify_content};
  border-radius: ${(props) => props.$border_radius};
  border: ${(props) => props.border};
  align-items: ${(props) => props.$align_item};
`
